import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link, Switch, Route, Redirect, BrowserRouter as Router } from 'react-router-dom';
import * as api from '../../apiUtils/api';
import {Bar, Doughnut, Line, Pie, Polar, Radar} from "react-chartjs-2";
import {CardColumns, Card, CardHeader, CardBlock} from "reactstrap";

import { getTasks,refreshTasks } from '../../apiUtils/api';
import * as taskActions from '../../redux/tasks/actions';
import TaskRender from '../TaskRender/';

class TaskCard extends Component {

  taskClick(){
    this.props.taskClick(this.props.task);
  }

  renderProgressBar=(total_records,total_submited)=>{
    let progress=(total_submited/total_records) * 100;
    if (isNaN(progress)){
       progress=0;
    }else {
      progress=Math.ceil(progress);
    }
    return (
      <div className="progress">
        <div className="progress-bar" role="progressbar" style={{width: `${progress}%`}} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100">{progress}%</div>
      </div>
    )
  }

  getWorkerTaskStat=(paramWorkerTaskStats)=>{
    const { user } = this.props.auth;
    let workerTaskStats = paramWorkerTaskStats.filter((wts)=>wts.worker_id==user.id)
    return workerTaskStats.length>0?workerTaskStats[0]:null;
  }

  render(){
    const {id,task_name,total_records,total_accepted,total_submited,total_available, task_type, workerTaskStats} = this.props.task;
    let totalAvailable=total_available;
    let totalRecords=total_records;
    let totalAccepted=total_accepted;
    let totalSubmitted=total_submited;
    let trainOrQualiModeLoading=false;

    if (workerTaskStats && (task_type==='TRAIN' || task_type==='QUALI')){
       const wts=this.getWorkerTaskStat(workerTaskStats)
       if (wts){
          totalAvailable=wts.total_available;
          totalRecords=wts.total_records;
          totalAccepted=wts.total_accepted;
          totalSubmitted=wts.total_submitted;
       }
    }else {
      if (totalAvailable && (task_type==='TRAIN' || task_type==='QUALI') && !workerTaskStats){
          trainOrQualiModeLoading=true;
      }
    }
    
    if (totalAvailable && !trainOrQualiModeLoading){
      return (
        <div key={id} className="col-sm-4">
          <div className="card taskCategoryContainer" onClick={this.taskClick.bind(this)}>
            <div className="card-body">
              <h4 className="card-title">{task_name}</h4>
              {this.renderProgressBar(totalRecords,totalSubmitted)}
              <p className="card-text">Total Tasks: {totalRecords}</p>
              <p className="card-text">Tasks Accepted: {totalAccepted}</p>
              <p className="card-text">Tasks Available: {totalAvailable}</p>
            </div>
          </div>
        </div>
      );
    }else{
      if (totalAccepted){
        return (
          <div key={id} className="col-sm-4">
            <div className="card taskCategoryContainer" onClick={this.taskClick.bind(this)} >
              <div className="card-body">
                <h4 className="card-title">{task_name}</h4>
                {this.renderProgressBar(totalRecords,totalSubmitted)}
                <p className="card-text">Total Tasks: {totalRecords}</p>
                <p className="card-text">Tasks Accepted: {totalAccepted}</p>
                <p className="card-text">Tasks Available: {totalAvailable}</p>
              </div>
            </div>
          </div>
        );
      }else {
        if (trainOrQualiModeLoading){
          const msg=`You have ${task_type==='TRAIN'?'training':'qualification'} tasks. Please wait...`
          return (
            <div key={id} className="col-sm-4">
              <div className="card" style={{width: 300}}>
                <div className="card-body">
                  <h4 className="card-title">{task_name}</h4>
                  <p className="card-text">{msg}</p>
                </div>
              </div>
            </div>
          );
        }else {
          return (
            <div key={id} className="col-sm-4">
              <div className="card" style={{width: 300}}>
                <div className="card-body">
                  <h4 className="card-title">{task_name}</h4>
                  <p className="card-text">Task not available!</p>
                </div>
              </div>
            </div>
          );
        }
        
      }
    }
    
  }
}
class Dashboard extends Component {
  state = {
    tasks: [],
    taskClicked: false
  }

  componentDidMount(){
    //this.grabData();
    this.refreshTasksTimerId = setInterval(
      () => this.refreshTasks(),
      10000
    )
  }

  componentWillUnmount(){
    clearInterval(this.refreshTasksTimerId);
  }

  refreshTasks(){
    const { auth,taskDist } = this.props;
    this.props.refreshTasksList(auth.jwtToken,taskDist.taskCategoryId);
    //this.grabData();
  }

  componentWillMount(){
    this.props.tasksListUIAcknowledge();
    //this.grabData();
  }

  taskClick(task){
    this.props.taskSelect(task);
  }

  render() {
    const { taskDist,auth } = this.props;

    if (taskDist.taskSelected){
      clearInterval(this.refreshTasksTimerId);
      return <Redirect push to='/taskAcceptance' />;
    }

    const taskElements = taskDist.tasks.map((task)=>{
      return (
        <TaskCard taskClick={this.taskClick.bind(this)} key={task.id} task={task} auth={auth} />
      )
    })

    return (
      <div className="container">
        <div className='row'>
           <br />
        </div>   
        <Switch>
          <Route exact path='/dashboard' render={props => (
            <div className="row">
              {taskElements}
            </div>
          )}/>
          <Route exact path='/taskRender' component={TaskRender} />
        </Switch>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth,
    taskDist: state.taskDist
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    taskSelect: (task) => {
      dispatch(taskActions.taskSelect(task))
    },
    tasksListUIAcknowledge: () => {
      dispatch(taskActions.tasksListUIAcknowledge())
    },
    refreshTasksList: (jwt,taskCategoryId) => {
      dispatch(taskActions.refreshTasksList(jwt,taskCategoryId))
    }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(Dashboard);


// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js